module.exports = __webpack_public_path__ + "static/media/Strata.9a06a948.png";